import { isDefined } from "@omni/utils/helper.utils";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useBFFCartServiceApi } from "@/api/hooks/cartService.hook";
import { CartModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import * as CartSelectors from "@/redux/modules/api/data/cart/cart.selectors";
import CallService, { CallServiceKey } from "@/services/call.service";

const getItemsCount = (cart: CartModel) => {
    return cart.items
        .filter((item) => !item.isAdditionalService)
        .map((item) => item.quantity)
        .reduce((sum, quantity) => {
            sum += quantity;
            return sum;
        }, 0);
};

export const useCartItemsCount = () => {
    const cart = useSelector(CartSelectors.getCart);
    const isLoadingCart = useSelector(CartSelectors.isLoadingCart);

    const [{ data: count, loading: isLoadingCount, error }, loadCount] =
        useBFFCartServiceApi<never, never, number>(
            {
                url: "/carts/items/count",
                method: "GET"
            },
            {
                manual: true
            }
        );

    useEffect(() => {
        if (cart) return;
        if (error) return;
        if (isLoadingCart) return;
        if (isLoadingCount) return;
        if (isDefined(count)) return;

        loadCount()
            .then(({ data }) => {
                if (data === 0) {
                    CallService.disable(CallServiceKey.Cart);
                } else {
                    CallService.enable(CallServiceKey.Cart);
                }
            })
            .catch(() => {
                CallService.enable(CallServiceKey.Cart);
            });
    }, [count, cart, error, isLoadingCart, isLoadingCount, loadCount]);

    const itemsCount = cart ? getItemsCount(cart) : count;

    return { count: itemsCount };
};
